module.exports = __webpack_public_path__ + "static/media/Octicons.f7c53c47.ttf";